import {useState} from 'react'
import {getLaundryOperationById} from '../services'
// import {SelectModel} from '../model'
const useLaundryOperationList = () => {
  const [loading, setLoading] = useState(false)
  //   const [pointList, setPointList] = useState<SelectModel[]>([])

  const getLaundryOperationByIdAPI = async (id: string) => {
    return await getLaundryOperationById(id)
  }

  const getLaundryOperationDataById = async (id: string = '') => {
    setLoading(true)
    try {
      const response = await getLaundryOperationByIdAPI(id)
      return response.data
    } catch (error) {
      console.error('Error fetching point data:', error)
      throw error
    } finally {
      setLoading(false)
    }
  }

  //   const handleClear = () => {
  //     setPointList([])
  //   }

  return {
    loading,
    // pointList,
    // handleClear,
    getLaundryOperationDataById,
  }
}

export default useLaundryOperationList
